import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const encodePublicUrlOnTouch = isFeature('encode-public-url-on-touch');
